import { render, staticRenderFns } from "./EnterpriseInquiriesForm.vue?vue&type=template&id=bbcb72b8&scoped=true"
import script from "./EnterpriseInquiriesForm.vue?vue&type=script&lang=js"
export * from "./EnterpriseInquiriesForm.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseInquiriesForm.vue?vue&type=style&index=0&id=bbcb72b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb72b8",
  null
  
)

export default component.exports